import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Google Analytics 4 `page_view` event whenever the React route
 * changes. The initial page_view is sent inline by index.html so we skip
 * the first effect run to avoid double-counting.
 */
export default function GaRouteTracker() {
  const location = useLocation();
  const firstRun = useRef(true);

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    if (typeof window === "undefined" || typeof window.gtag !== "function") {
      return;
    }
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
